import { SAVECART_MODAL_SHOW, SAVECART_MODAL_HIDE, SAVECART_MODAL_UPDATE } from "../Actions/SaveCartPopUp.action";
const defaultState = {  
  showSavecartPop:false
};
export const savecartpopup = (state = defaultState, action) => {
  const { type, payload } = action;
  switch (type) {
    case SAVECART_MODAL_SHOW:
      return {
        ...state,
        ...action.payload,
        showSavecartPop: true
      };
    case SAVECART_MODAL_HIDE:
      return {
        ...state,
        ...action.payload,
        showSavecartPop: false
      };     
    default:
      return state;
  }
};
